import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  STAKEHOLDER_FEATURE_KEY,
  StakeholderState,
  StakeholderPartialState,
  stakeholderAdapter,
  
} from './stakeholder.reducer';

// Lookup the 'Stakeholder Reference' feature state managed by NgRx
export const getStakeholderState = createFeatureSelector<
StakeholderPartialState,
StakeholderState
>(STAKEHOLDER_FEATURE_KEY);



const { selectAll, selectEntities } = stakeholderAdapter.getSelectors();






export const getStakeholderError = createSelector(
    getStakeholderState,
  (state: StakeholderState) =>  state.error
);

export const loadingStakeholder = createSelector(
    getStakeholderState,
  (state: StakeholderState) =>  state.loaded
);

export const getAllStakeholder = createSelector(
    getStakeholderState,
  (state: StakeholderState) => selectAll(state)
);

export const getStakeholderEntities = createSelector(
    getStakeholderState,
  (state: StakeholderState) => selectEntities(state)
);

export const getSelectedId = createSelector(
    getStakeholderState,
  (state: StakeholderState) => state.selectedStakeholderId
);

export const getSelected = createSelector(
    getStakeholderEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);






